const FanListIcon = ({ size = 35, className = "", ...props }) => {
  const {color}=props
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Fan center */}
      <circle cx={8} cy={12} r={2} fill={color?color:"white" }/>

      {/* Fan blades */}
      <path
        d="M8 4c2 0 3 2 2 4-1 1-3 2-4 1-1-1 0-3 2-5z"
        fill={color?color:"white" }
      />
      <path
        d="M16 12c0 2-2 3-4 2-1-1-2-3-1-4 1-1 3 0 5 2z"
        fill={color?color:"white" }
      />
      <path
        d="M8 20c-2 0-3-2-2-4 1-1 3-2 4-1 1 1 0 3-2 5z"
        fill={color?color:"white" }
      />
      <path
        d="M0 12c0-2 2-3 4-2 1 1 2 3 1 4-1 1-3 0-5-2z"
        fill={color?color:"white" }
      />

      {/* List icon */}
      <rect x={14} y={6} width={8} height={2} fill={color?color:"white" } />
      <rect x={14} y={11} width={8} height={2} fill={color?color:"white" } />
      <rect x={14} y={16} width={8} height={2} fill={color?color:"white" } />
    </svg>
  );
};

export default FanListIcon;